import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/enterprise-center/arrow-icon.svg';
import _imports_1 from '@/assets/images/enterprise-center/add-icon.svg';
import _imports_2 from '@/assets/images/enterprise-center/ellipse-icon.svg';
import _imports_3 from '@/assets/images/enterprise-center/role-auth-edit.svg';
import _imports_4 from '@/assets/images/enterprise-center/role-auth-delete.svg';
const _withScopeId = n => (_pushScopeId("data-v-4abcd4a9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tc-tree"
};
const _hoisted_2 = ["onClick", "id"];
const _hoisted_3 = {
  class: "operate-btns"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_10 = {
  class: "item-line"
};
const _hoisted_11 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tcTree = _resolveComponent("tcTree", true);
  return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.treeData, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "tc-tree-item",
      key: item.id,
      onClick: _withModifiers($event => $setup.handleClickTitle(item), ["stop"]),
      id: item.id
    }, [_createElementVNode("div", {
      class: "item-title",
      style: _normalizeStyle(`font-weight:${$props.propsFontWeight}`),
      onMouseleave: _cache[1] || (_cache[1] = $event => _ctx.showId = null)
    }, [item.children && item.children.length ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "item-title-arrow",
      src: _imports_0,
      style: _normalizeStyle(_ctx.selectedId == item.id ? `transform: rotate(90deg);` : '')
    }, null, 4)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.name) + " ", 1), _createElementVNode("div", _hoisted_3, [$props.propsCountLevel < $props.propsHideLevel && item.is_dir !== 2 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "operate-btns-add",
      src: _imports_1,
      onClick: _withModifiers($event => $setup.handleAddDepartment(item), ["stop"])
    }, null, 8, _hoisted_4)) : _createCommentVNode("", true), $props.propsCountLevel < $props.propsHideLevel + 1 && $props.propsShowEllipse ? (_openBlock(), _createElementBlock("img", {
      key: 1,
      class: "operate-btns-ellipse",
      src: _imports_2,
      alt: "",
      onClick: _withModifiers($event => $setup.handleShow($event, item), ["stop"])
    }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "operate",
      style: _normalizeStyle({
        display: _ctx.showId == item.id ? 'block' : 'none'
      }),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [_createElementVNode("div", {
      onClick: $event => $setup.handleEditDepartment(item),
      class: "operate-edit"
    }, [_hoisted_7, _createTextVNode("编辑 ")], 8, _hoisted_6), _createElementVNode("div", {
      onClick: $event => $setup.handleDeleteDepartment(item),
      class: "operate-del"
    }, [_hoisted_9, _createTextVNode("删除")], 8, _hoisted_8)], 4)], 36), item.children && item.children.length ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "item-children",
      style: _normalizeStyle(_ctx.selectedId === item.id ? 'grid-template-rows:1fr;' : 'grid-template-rows:0fr')
    }, [_createVNode(_component_tcTree, {
      treeData: item.children,
      propsHandleAddDepartment: $props.propsHandleAddDepartment,
      nodeClick: $props.nodeClick,
      propsHideLevel: $props.propsHideLevel,
      propsFontWeight: 500,
      propsShowLine: false,
      propsCountLevel: $props.propsCountLevel + 1,
      propsShowEllipse: $props.propsShowEllipse,
      propsHandleEditDepartment: $props.propsHandleEditDepartment,
      propsHandleDeleteDepartment: $props.propsHandleDeleteDepartment
    }, null, 8, ["treeData", "propsHandleAddDepartment", "nodeClick", "propsHideLevel", "propsCountLevel", "propsShowEllipse", "propsHandleEditDepartment", "propsHandleDeleteDepartment"])], 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [$props.propsShowLine ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true)])], 8, _hoisted_2);
  }), 128))]);
}